import { connect } from 'react-redux';
import { getInviteForExtension } from 'actions/Invite';
import ContactDetails from 'components/Contacts/ContactDetails';
import _get from 'lodash/get';

const mapDispatchToProps = (dispatch, ownProps) => ({
  getInviteForExtension: async () => dispatch(getInviteForExtension(_get(ownProps, 'contact.extension')))
});

export default connect(() => ({}), mapDispatchToProps)(ContactDetails);
